import * as React from 'react';
import CircleDisplay from 'nomst/Components/SharedJobCollab/circleDisplay';
import './summaryCard.scss';

interface SummaryCardProps {
    heading?: string;
    subHeading?: string|JSX.Element;
    isTempItem?: boolean;
    circleDisplay?: string;
    circleClassName?: string;
    goToUrl?: string;
    id: Nullable<string|number>;
    circleIcon?: string;
    className?: string;
    onClickHandler?: () => void;
}

class SummaryCard extends React.Component<SummaryCardProps, {}> {

    constructor(props: SummaryCardProps) {
        super(props);
        this.handleRowClick = this.handleRowClick.bind(this);
    }

    render(): React.ReactNode {
        const {
            heading,
            subHeading,
            circleDisplay,
            circleClassName,
            circleIcon,
            className } = this.props;

        return (
            <button className={`summary-card pxl-link ${className || ''}`} onClick={this.handleRowClick} type="button">
                { this._renderCircle(circleDisplay, circleClassName, circleIcon) }
                { this._renderText(heading, subHeading) }
            </button>
        );
    }

    private handleRowClick(): void {
        if(this.props.onClickHandler && this.props.id) {
            this.props.onClickHandler();
        }
    }

    private _renderCircle(heading?: string, className?: string, circleIcon?: string): React.ReactNode {
        return (
            <CircleDisplay
                heading={heading}
                className={className}
                circleIcon={circleIcon}
            />
        );
    }

    private _renderText(heading?: string, subHeading?: string|JSX.Element): React.ReactNode {
        return (
            <div className="summary-card-text">
                <h5 className="summary-card-header">
                    <span>{heading}</span>
                </h5>
                <div className="summary-card-subheader">
                    <span>{subHeading}</span>
                </div>
            </div>
        );
    }
}

export { SummaryCard };
export default SummaryCard;